import { render } from "./IntegrationApp.vue?vue&type=template&id=278a4c21&scoped=true"
import script from "./IntegrationApp.vue?vue&type=script&lang=js"
export * from "./IntegrationApp.vue?vue&type=script&lang=js"

import "./IntegrationApp.vue?vue&type=style&index=0&id=278a4c21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278a4c21"]])

export default __exports__